import admin from "../middleware/admin";
import auth from "../middleware/auth";

export default {
  path: "kategorijas-sabloni",
  name: "view-template-categories",
  meta: {
    middleware: [auth, admin]
  },
  component: () => import("@/components/categories/TemplateCategories"),
};
